<template>
  <div class="bgFrame">
    <div class="box" style="z-index: 500;position: relative;">
      <img src="../../assets/tab2_banner1.png" class="bgImg" />
    </div>
    <div class="boxs" :style="'background-image: url(' + pointImg + ');'">
    </div>
    <div
      class="box"
      style="z-index: 502; display: flex; justify-content: center"
    >
      <div class="textFrame">
        <div style="width: 100%; margin-top: 104px;"></div>
        <div style="display: flex; justify-content: center">
          <div :class="titleClass" v-if="realData">{{realData.title}}</div>
        </div>
        <div style="width: 100%; margin-top: 10px;"></div>
        <div style="display: flex; justify-content: center">
          <div :class="contentClass" v-if="realData" v-html="realData.describes"></div>
        </div>
        <div style="width: 100%; margin-top: 62px"></div>
        <div class="largeImg">
          <div class="leftImgFrame">
            <img v-if="realData && realData.leftUrl != ''" :class="leftImgClass" :src="realData.leftUrl" />
          </div>
          <div class="rightImgFrame">
            <img v-if="realData && realData.rightUrl != ''" :class="rightImgClass" :src="realData.rightUrl" />
          </div>
          <div class="topImgFrame">
            <img
              v-if="realData && realData.mainUrl != ''"
              :src="realData.mainUrl"
              :class="largeImgClass"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted , watch } from "vue";

export default {
  name: "App",
  components: {},
  props: {
    design: Object,
  },
  setup(props) {
    const realData = ref({
      leftUrl: '',
      title: '',
      describes: '',
      rightUrl: '',
      mainUrl: ''
    })
    watch(
        () => props.design,
            (newProps) => {
                realData.value = newProps
            }
        );

    onMounted(() => {
      realData.value = props.design
    });

    let titleClass = ref("start_textSubFrame");
    let contentClass = ref("start_textContent");
    let largeImgClass = ref("start_topImg");
    let leftImgClass = ref("start_leftImg");
    let rightImgClass = ref("start_rightImg");

    const startAnime = ref(false);
    const changeAnime = () => {
    titleClass.value = "start_textSubFrame";
    contentClass.value = "start_textContent";
    largeImgClass.value = "start_topImg";
    leftImgClass.value = "start_leftImg";
    rightImgClass.value = "start_rightImg";

    setTimeout(() => {
      if (startAnime.value == false) {
        titleClass.value = "textSubFrame";
        setTimeout(() => {
          contentClass.value = "textContent";
        }, 500);
        setTimeout(() => {
          largeImgClass.value = "topImg";
        }, 1000);
        setTimeout(() => {
          leftImgClass.value = "leftImg";
          rightImgClass.value = "rightImg";
        }, 1500);
      }
    }, 100);
    };
    let pointImg = ref(require('../../assets/noise.png'))
    return {
      realData,
      pointImg,
      startAnime,
      titleClass,
      contentClass,
      largeImgClass,
      changeAnime,
      leftImgClass,
      rightImgClass
    };
  },
};
</script>

<style lang="less" scoped>
@keyframes pointAnime{
  0% {
    transform: translate3d(0,9px,0)
  }
  10% {
    transform: translate3d(-1px,-4px,0)
  }
  20% {
    transform: translate3d(-8px,2px,0)
  }
  30% {
    transform: translate3d(-9px,-9px,0)
  }
  40% {
    transform: translate3d(2px,7px,0)
  }
  50% {
    transform: translate3d(9px,-4px,0)
  }
  60% {
    transform: translate3d(2px,6px,0)
  }
  70% {
    transform: translate3d(7px,-8px,0)
  }
  80% {
    transform: translate3d(-9px,1px,0)
  }
  90% {
    transform: translate3d(6px,-5px,0)
  }
  to {
    transform: translate3d(-7px,0,0)
  }
}

.bgFrame {
  width: 100%;
  height: 100%;
  overflow: hidden;

}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  background-position:50%;
  animation :pointAnime 1s steps(2) infinite;
}
.box{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.bgImg{
  height: 100%;
  min-height: 878px;
  position: absolute;
  top: 0;
  object-fit: cover;
}
.mainImg {
  width: calc(100% / 1080 * 450);
  height: 450 / 518;
  margin-left: calc(100% / 1080 * 574);
}

.textFrame {
  height: 100%;
  width: 968px;
  display: flex;

  flex-direction: column;
  align-content: center;
}

@keyframes textSubAnime {
  from {
    transform: translate(0px, 20px);
    opacity: 0;
  }
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
.textSubFrame {
  font-size: 67px;
  font-family: MicrosoftYaHeiLight;
  color: #243C05;
  opacity: 1;
  animation-name: textSubAnime;
  animation-duration: 0.7s;
  animation-timing-function: ease-in-out;
}

.start_textSubFrame {
  font-size: 67px;
  font-family: MicrosoftYaHeiLight;
  color: #243C05;
  opacity: 0;
}
.textImg {
  width: calc(100% / 338 * 312);
  aspect-ratio: 312 / 19;
}

@keyframes textContentAnime {
  from {
    transform: translate(0px, 20px);
    opacity: 0;
  }
  to {
    transform: translate(0px, 0px);
    opacity: 1;
  }
}
.textContent {
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  color: #243C05;
  opacity: 1;
  animation-name: textContentAnime;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  line-height: 29px;
}
.start_textContent {
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  color: #243C05;
  opacity: 0;
  line-height: 29px;
}
.largeImg {
  position: relative;
  width: 100%;
  padding-top: 52%;
  display: flex;
  .topImgFrame {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 501;
    display: flex;
    justify-content: center;
    align-items: center;
    @keyframes topImgAnime {
      0% {
        transform: translate(0px, 40px);
        opacity: 0;
      }
      60% {
        opacity: 1;
      }
      100% {
        transform: translate(0px, 0px);
        opacity: 1;
      }
    }
    .topImg {
      width: calc(100% / 594 * 338);
      object-fit: contain;
      opacity: 1;
      animation-name: topImgAnime;
      animation-duration: 1.5s;
      animation-timing-function: ease-in-out;
    }
    .start_topImg {
      width: calc(100% / 594 * 338);
      object-fit: contain;
      opacity: 0;
    }
  }
  .leftImgFrame {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 3%;
    z-index: 500;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @keyframes leftImgAnime {
      from {
        transform: translate(60px, 0px);
        opacity: 0;
      }
      to {
        transform: translate(0px, 0px);
        opacity: 1;
      }
    }
    .leftImg {
      width: calc(100% / 594 * 203);
      object-fit: contain;
      opacity: 1;
      animation-name: leftImgAnime;
      animation-duration: 1.5s;
    }
    .start_leftImg {
      width: calc(100% / 594 * 203);
      object-fit: contain;
      opacity: 0;
    }
  }

  .rightImgFrame {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 500;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @keyframes rightImgAnime {
      from {
        transform: translate(-60px, 0px);
        opacity: 0;
      }
      to {
        transform: translate(0px, 0px);
        opacity: 1;
      }
    }
    .rightImg {
      width: calc(100% / 594 * 163);
      margin-right: calc(100% / 594 * 30);
      object-fit: contain;
      opacity: 1;
      animation-name: rightImgAnime;
      animation-duration: 1.5s;
    }
    .start_rightImg {
      width: calc(100% / 594 * 163);
      margin-right: calc(100% / 594 * 30);
      object-fit: contain;
      opacity: 0;
    }
  }
}
</style>
